export default "__VITE_ASSET__CzHJ6kdw__"